<template>
  <div class="canlender-child" ref="canlender" :style="{backgroundImage: 'url('+imgUrl+')'}">
    <div class="canlender-icons" :style="{top: top + 'px'}">
      <div class="tomato">
        <span class="icon" :style="{backgroundImage: 'url('+tomatoUrl+')'}"></span>
      </div>
      <div class="icon-bottom">
        <span class="f-r icon drink" :style="{backgroundImage: 'url('+drinkUrl+')'}" v-if="canlenderInfoB.drink_on"></span>
        <span class="f-r icon pill" :style="{backgroundImage: 'url('+pillUrl+')'}" v-if="canlenderInfoB.cure_on"></span>
      </div>
    </div>
  </div>
</template>
<script>
import Common from '../../../assets/js/common.js'
export default {
  name: 'WeiYi',
  props: {
    canlenderInfo: Object,
    imgUrl: String
  },
  data () {
    return {
      imgUrlBase: this.imgUrl,
      canlenderInfoB: this.canlenderInfo,
      tomatoUrl: Common.staticHref() + 'img/tomatoIcon.png',
      drinkUrl: Common.staticHref() + 'img/drinkIcon.png',
      pillUrl: Common.staticHref() + 'img/pillIcon.png',
      top: ''
    }
  },
  methods: {
    computedtop () {
      let canlenderH = this.$refs.canlender.offsetHeight
      let canlenderW = this.$refs.canlender.offsetWidth
      let top = (canlenderH - (canlenderW * 1.347)) / 2 + 50
      return top
    }
  },
  watch: {
    imgUrl (newValue) {
      this.imgUrlBase = newValue
    },
    canlenderInfo (newValue) {
      if (!newValue) return
      this.canlenderInfoB = newValue
    }
  },
  mounted () {
    this.top = this.computedtop()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.canlender-child
  width 100%
  height 100%
  backgroundImg()
  .canlender-icons
    position absolute
    right 16px
    .tomato
      rowCenter()
    .icon-bottom
      padding-top 8px
    .icon
      display inline-block
      width 16px
      height 16px
      background-position center center
      background-repeat no-repeat
      background-size contain
    span
      font-size 16px
      margin-left 8px
</style>


// WEBPACK FOOTER //
// src/canlender/StyleCommponent/WeiYi/WeiYi.vue